import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=91f1d0ac&scoped=true&"
import script from "./sideBar.vue?vue&type=script&lang=ts&"
export * from "./sideBar.vue?vue&type=script&lang=ts&"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=91f1d0ac&lang=scss&scoped=true&"
import style1 from "./sideBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f1d0ac",
  null
  
)

export default component.exports